import {BelegKetteDTO} from '../../openapi/fakturierung-openapi';


/**
 * Belegkette (Ursprung, Vorgaenger und Nachfolger per Konvertierung) je Beleg,
 * geladen ueber den separaten kette-Endpoint.
 */
export interface BelegKetteState {
  byBelegId: Record<string, BelegKetteDTO>;
}


export const initialBelegKetteState: BelegKetteState = {
  byBelegId: {},
};
